export default "__VITE_ASSET___L49gQFr__"